export default __webpack_public_path__ + "static/media/E.cd349e07.svg";